import React, { useState } from "react";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import CustomTitleAccount from "./customTitleAccount";
import CustomPasswordInput from "./customPasswordInput";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updateUserPassword } from "../../redux/reducer/userAddressReducer";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const AccountPasswordSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigateWithLang = useLanguageNavigate();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  const handleSave = () => {
    if (newPassword !== confirmPassword) {
      alert(t("PasswordsDoNotMatch"));
      return;
    }

    if (!oldPassword || !newPassword || !confirmPassword) {
      alert(t("AllFieldsRequired"));
      return;
    }

    dispatch(updateUserPassword({ oldPassword, newPassword }));
    setIsEditing(false);
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    navigateWithLang("/my-account");
    window.location.reload();
  };

  const handleInputChange = (setter, fieldName) => (e) => {
    const newValue = e.target.value;
    setter(newValue);

    // Check if all fields are not empty to activate the "Save" button
    const allFieldsFilled = oldPassword && newPassword && confirmPassword;
    setIsEditing(allFieldsFilled);
  };

  return (
    <div className="w-full">
      <CustomTitleAccount
        title={t("ChangePassword")}
        icon={<LockClosedIcon className="w-8 h-8 text-black" />}
        isEditing={isEditing}
        onClick={isEditing ? handleSave : null}
      />

      <div className="mt-2 space-y-4 md:mt-4">
        <div className="w-1/2">
          <CustomPasswordInput
            id="password1"
            label={t("OldPassword")}
            placeholder={t("EnterYourOldPassword")}
            value={oldPassword}
            onChange={handleInputChange(setOldPassword, "oldPassword")}
          />
        </div>
        <div className="flex w-full gap-3">
          <CustomPasswordInput
            id="password2"
            label={t("NewPassword")}
            placeholder={t("EnterNewPassword")}
            value={newPassword}
            onChange={handleInputChange(setNewPassword, "newPassword")}
          />
          <CustomPasswordInput
            id="password3"
            label={t("ConfirmPassword")}
            placeholder={t("ConfirmNewPassword")}
            value={confirmPassword}
            onChange={handleInputChange(setConfirmPassword, "confirmPassword")}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountPasswordSection;
